import React from 'react'
import styled from '../../theme'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  getAirbnbAgreement,
  getAirbnbListings,
  getAirbnbStatus,
  getAirbnbTab,
} from '../../reducers/airbnb/selectors'
import { IntegrationStatus } from '../../reducers/airbnb'
import { FiExternalLink } from 'react-icons/fi'
import lockdown from '../../assets/integrations/lockdown.svg'
import currency from '../../assets/integrations/currency.svg'
import duplicate from '../../assets/integrations/duplicate.svg'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import { getUserLanguage } from '../../reducers/userAccount/selectors/userAccount'
import { is } from '../../components/MediaQuery'

export const Card = styled.div<{ active?: boolean }>`
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  border-radius: 5px;
  margin-bottom: 20px;
  margin-top: 10px;
  opacity: 50%;
  transition: opacity 0.3s ease-in-out;
  ${({ active }) =>
    active &&
    `
  opacity: 100%;
  `}
`

export const Title = styled.div<{ active?: boolean }>`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #000000;
  text-decoration: none solid rgb(0, 0, 0);
  font-weight: bold;
  margin-bottom: 3px;
  opacity: 50%;
  transition: opacity 0.3s ease-in-out;
  ${({ active }) =>
    active &&
    `
  opacity: 100%;
  `}
`

const CardTitle = styled.div<{ active?: boolean }>`
  font-size: 13px;
  font-weight: bold;
  transition: color 0.3s ease-in-out;
  ${({ active }) => active && `color: #07a944;`}
`

export const CardText = styled.div`
  font-size: 13px;
`

function Help() {
  const { t } = useTranslation()
  const listings = useSelector(getAirbnbListings)
  const agreement = useSelector(getAirbnbAgreement)
  const tab = useSelector(getAirbnbTab)
  const isDesktop = is.desktop()
  const lang = useSelector(getUserLanguage)
  const premium = useSelector(isLicenseValid)

  const everyConnected =
    listings.length && listings.every(l => !!l.bedbooking_id_room)

  const status = useSelector(getAirbnbStatus)

  const onClick = () => {
    let link = ''

    switch (lang) {
      case 'pl':
      case 'pl_PL':
        link =
          'https://support.bed-booking.com/hc/pl/articles/4410609625106-Roz%C5%82%C4%85czenie-BedBooking-jako-Channel-Manager-a '
        break
      case 'it':
        link =
          'https://support.bed-booking.com/hc/it/articles/4410609625106-Disconnettere-BedBooking-come-Channel-Manager'

        break
      case 'es':
        link =
          'https://support.bed-booking.com/hc/es-es/articles/4410609625106-Desconectar-BedBooking-como-Channel-Manager '
        break
      case 'en':
      default:
        link =
          'https://support.bed-booking.com/hc/en-us/articles/4410609625106-Disconnecting-BedBooking-as-Channel-Manager'
        break
    }

    window.open(link, '_blank')
  }

  return (
    <div style={!isDesktop ? {} : { paddingRight: '18px' }}>
      {premium && (
        <>
          <Title
            active={!everyConnected}
            dangerouslySetInnerHTML={{
              __html: t('OUT_4832_instruction_title_1'),
            }}
          />
          <Card active={!everyConnected && !agreement && tab === 0}>
            <CardTitle
              active={!everyConnected && !agreement && tab === 0}
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_1'),
              }}
            />
            <CardText
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_1_1'),
              }}
            />
          </Card>
          <Card
            active={
              !everyConnected &&
              agreement &&
              tab === 0 &&
              status === IntegrationStatus.NotIntegrated
            }
          >
            <CardTitle
              active={
                !everyConnected &&
                agreement &&
                tab === 0 &&
                status === IntegrationStatus.NotIntegrated
              }
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_2'),
              }}
            />
            <CardText
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_2_1'),
              }}
            />
          </Card>
          <Card
            active={!everyConnected && status === IntegrationStatus.Integrated}
          >
            <CardTitle
              active={
                !everyConnected && status === IntegrationStatus.Integrated
              }
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_3'),
              }}
            />
            <CardText
              style={{
                marginBottom: '10px',
              }}
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_3_1'),
              }}
            />
            <CardText
              dangerouslySetInnerHTML={{
                __html: t('OUT_4832_instruction_module_3_2'),
              }}
            />
          </Card>
          <Title
            active={tab === 1}
            dangerouslySetInnerHTML={{
              __html: t('OUT_4832_instruction_module_edit'),
            }}
          />
          <Card active={tab === 1}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <CardText
                dangerouslySetInnerHTML={{
                  __html: t('OUT_4832_instruction_module_edit_1'),
                }}
              />
            </div>
          </Card>
          <Title
            active={tab === 1}
            dangerouslySetInnerHTML={{
              __html: t('OUT_4832_instruction_module_disconnect'),
            }}
          />
          <Card active={tab === 1}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <CardText
                dangerouslySetInnerHTML={{
                  __html: t('OUT_4832_instruction_module_disconnect_1'),
                }}
              />
            </div>
          </Card>

          {tab === 1 && (
            <>
              <Title
                active={true}
                dangerouslySetInnerHTML={{
                  __html: t('OUT_4832_instruction_module_4'),
                }}
              />

              <Card active={true}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <img
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: '10px',
                      filter:
                        'invert(45%) sepia(34%) saturate(6443%) hue-rotate(121deg) brightness(97%) contrast(94%)',
                    }}
                    alt={'lockdown'}
                    src={lockdown}
                  />
                  <CardText
                    dangerouslySetInnerHTML={{
                      __html: t('BED_22719_text_1'),
                    }}
                  />
                </div>
              </Card>
              <Card active={true}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <img
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: '10px',
                      filter:
                        'invert(45%) sepia(34%) saturate(6443%) hue-rotate(121deg) brightness(97%) contrast(94%)',
                    }}
                    alt={'currency'}
                    src={currency}
                  />
                  <CardText
                    dangerouslySetInnerHTML={{
                      __html: t('OUT_4830_airbnb_logging_keeponmind_3'),
                    }}
                  />
                </div>
              </Card>
              <Card active={true}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <img
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: '10px',
                      filter:
                        'invert(45%) sepia(34%) saturate(6443%) hue-rotate(121deg) brightness(97%) contrast(94%)',
                    }}
                    alt={'duplicate'}
                    src={duplicate}
                  />
                  <CardText
                    dangerouslySetInnerHTML={{
                      __html: t('OUT_4830_airbnb_logging_keeponmind_4'),
                    }}
                  />
                </div>
              </Card>
            </>
          )}
        </>
      )}

      {!premium && (
        <>
          <Title
            active={true}
            dangerouslySetInnerHTML={{
              __html: t('OUT_4832_instruction_title_1'),
            }}
          />
          <Card active={true}>
            <CardTitle
              active={true}
              dangerouslySetInnerHTML={{
                __html: t('OUT_4258_airbnb_no_premium_button_2'),
              }}
            />
            <CardText
              dangerouslySetInnerHTML={{
                __html: t('OUT_4831_no_premium_window_2'),
              }}
            />
          </Card>
        </>
      )}

      <Title
        active={tab === 1}
        dangerouslySetInnerHTML={{
          __html: t('OUT_4832_instruction_disconnect_account_module'),
        }}
      />
      <Card active={tab === 1}>
        <CardText
          onClick={onClick}
          style={{
            cursor: 'pointer',
          }}
        >
          {t('OUT_4832_instruction_disconnect_account_module_1')}
          <FiExternalLink style={{ fontSize: '14px', marginLeft: '5px' }} />
        </CardText>
      </Card>
    </div>
  )
}

export default Help
